//this file consists of credentials for Auth0
import auth0 from 'auth0-js'
export const Auth0 = new auth0.WebAuth({
      domain: 'telpro.auth0.com',
      clientID: 'xBBQ84BgP6Xp5qm93Zr7p17VzD5iP9l7',
      // responseType: 'token'
      responseType: 'token id_token',
});